import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './ENS' // 英文
import zhLocale from './CNS' // 简体中文
import fnLocale from './FNS' // 繁体中文
console.log(enLocale, zhLocale)
Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale
  },
  zh: {
    ...zhLocale
  },
  fn: {
    ...fnLocale
  }
}
const langFn = ($type) => { // 根据url参数lang_id判断中英文
  const urlParams = new URLSearchParams(window.location.search)
  console.log('系统语言', navigator.language)
  if (urlParams.get('lang_id')) {
    switch (urlParams.get('lang_id')) { // 1-中文  2-繁体  3-英文
      case '2':
        return 'fn'
      case '3':
        return 'en'
      default: return 'zh'
    }
  } else {
    // 根据浏览器语言展示
    // en-us 英语
    // zh-cn 中文
    // zh-tw 台湾繁体
    // zh-mo 澳门繁体
    // zh-hk 香港繁体
    const language = (navigator.language || navigator.userLanguage)
    const $lang = language.toLowerCase()
    const $lang1 = $lang.split('-')[0]

    if ($lang1 == 'en') { // 英文
      return 'en'
    } else if ($lang == 'zh-tw' || $lang == 'zh-mo' || $lang == 'zh-hk') { // 中文
      return 'fn'
    } else {
      return 'zh'
    }
  }
}
console.log(langFn(), 'langFn')
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: langFn(),
  // set locale messages
  messages
})

export default i18n
